module.exports = __webpack_public_path__ + "img/SG.6ae2dc5b.svg";